import { useEffect } from "react";

// Zähler, damit verschachtelte Overlays das Scrollen erst freigeben, wenn das letzte schließt.
let lockCount = 0;
let previousOverflow = "";

/**
 * Sperrt das Scrollen der Seite im Hintergrund, solange ein Overlay offen ist.
 * PrimeReact-Dialoge machen das über `blockScroll` (components/common/Dialog),
 * eigene Overlays (`.modal-overlay`) nutzen diesen Hook.
 *
 * @param {boolean} active Overlay ist sichtbar
 */
export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        document.body.style.overflow = previousOverflow;
      }
    };
  }, [active]);
}
